(function() {
  if (window.weilaiWeeklySaleCountdownLoaded) return;
  window.weilaiWeeklySaleCountdownLoaded = true;

  var timeZone = 'Europe/London';

  function getParts(date) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      weekday: 'long',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(date);
    var map = {};
    parts.forEach(function(part) {
      map[part.type] = part.value;
    });
    return {
      year: Number(map.year),
      month: Number(map.month),
      day: Number(map.day),
      hour: Number(map.hour),
      minute: Number(map.minute),
      second: Number(map.second),
      weekday: map.weekday
    };
  }

  function zonedTimeToDate(year, month, day, hour, minute, second) {
    var targetAsUtc = Date.UTC(year, month - 1, day, hour, minute, second || 0);
    var guess = targetAsUtc;

    for (var i = 0; i < 3; i += 1) {
      var parts = getParts(new Date(guess));
      var guessAsWallUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
      guess -= guessAsWallUtc - targetAsUtc;
    }

    return new Date(guess);
  }

  function addDaysToYmd(parts, days) {
    var date = new Date(Date.UTC(parts.year, parts.month - 1, parts.day + days, 12, 0, 0));
    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth() + 1,
      day: date.getUTCDate()
    };
  }

  function getSaleWindow(now) {
    var parts = getParts(now);
    var weekdayIndex = {
      Sunday: 0,
      Monday: 1,
      Tuesday: 2,
      Wednesday: 3,
      Thursday: 4,
      Friday: 5,
      Saturday: 6
    }[parts.weekday];
    var sunday = addDaysToYmd(parts, -weekdayIndex);
    var tuesday = addDaysToYmd(sunday, 2);

    return {
      start: zonedTimeToDate(sunday.year, sunday.month, sunday.day, 0, 1, 0),
      end: zonedTimeToDate(tuesday.year, tuesday.month, tuesday.day, 23, 0, 0)
    };
  }

  function formatRemaining(ms) {
    var totalSeconds = Math.max(0, Math.floor(ms / 1000));
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    var output = [];

    if (days > 0) output.push(days + 'd');
    output.push(String(hours).padStart(2, '0') + 'h');
    output.push(String(minutes).padStart(2, '0') + 'm');
    output.push(String(seconds).padStart(2, '0') + 's');
    return output.join(' ');
  }

  function tickCountdowns() {
    var nodes = document.querySelectorAll('[data-weilai-weekly-sale-countdown]');
    if (!nodes.length) return;

    var now = new Date();
    var windowDates = getSaleWindow(now);
    var remaining = windowDates.end - now;

    nodes.forEach(function(node) {
      var timeNode = node.querySelector('[data-weilai-weekly-sale-countdown-time]');
      node.style.minHeight = window.matchMedia('(max-width: 575px)').matches ? '26px' : '28px';
      node.style.padding = '0 10px';
      node.style.lineHeight = '1';
      node.style.background = '#dbcea5';
      node.style.color = '#111';

      if (!timeNode || now < windowDates.start || now >= windowDates.end || remaining <= 0) {
        node.hidden = true;
        return;
      }

      timeNode.textContent = formatRemaining(remaining);
      node.hidden = false;
    });
  }

  tickCountdowns();
  window.setInterval(tickCountdowns, 1000);
})();
